import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import useApi from '../../utility/apiCall'; 
import API_URL from '../../config/config';
import { Modal } from 'react-bootstrap';
// Images
import welcomeBg from '../../img/welcome-bg.webp';
import CloseIcon from '../../components/CloseIcon';

export default function WelcomeBox() {
  const { apiCall } = useApi();
  const { state } = useAuth();
  const isInitialMount = useRef(true);
  const token = state.token || '';

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [infoShow, setInfoShow] = useState(false);
  
  const handleInfoClose = () => {
    setInfoShow(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
        setInfoShow(true); // Open modal after 3 seconds
    }, 1000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCall(API_URL + 'get-profile', {
          user_id: state.userData.id,
          token: token,
          nopaginate: 1,
        });
        if (response.data.success == '0') {
          setFirstName(response.data.data.first_name);
          setLastName(response.data.data.last_name);
        } else {
          // console.log(response.data);
          console.error('Failed to fetch user details:', response.data.error);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (isInitialMount.current) {
        isInitialMount.current = false;
        fetchData();
    }
  }, [token]);


  return (
    <>
    <div className="welcome-bx">
      <div className="wb-data">
        <div className="wb-heading">Welcome {firstName+" "+lastName}</div>
        <div className="wb-sub-heading">Are You Ready To Buy Your First Challenge?</div>
        <div className="wb-text">We Recommend You Go Through The FAQ Section First Before Starting A Challenge</div>
        <div className="d-flex cbi-gap-10px wb-btns mt-4">
          <Link to="/new-challenge" className="common-btn cb-white-fill cwf-am-hover"><span>New Challenge</span></Link>
          <Link to="https://fundedfirm.com/trading-rules" target='_blank' className="common-btn cb-white-outline cwo-hover"><span>Trading Rules</span></Link>
        </div>
        <img className="wb-img" src={welcomeBg} alt='' />
       </div>
    </div>

     {/* --- Information Modal Start --- */}
     <Modal className="zoom custom-content" centered show={infoShow} onHide={handleInfoClose}>
     <div className="custom-modal-header">
         {/* <div className="cmh-lable">Information</div> */}
         <CloseIcon onClick={handleInfoClose} />
     </div>

     <div className="custom-modal-body">
         <div className="legal-content">
             <p className='mt-0'>It is permissible to execute multiple trades in the same pair, but their classification depends on timing. A minimum gap of three minutes is required for trades to be considered separate orders.</p>
             
             <div className="legal-heading mt-4">For example:</div>
             <p className='mt-2'>A trade executed at 10:00 AM and another at 10:01 AM will be merged into a single order.</p>
             <p className='mt-2'>A trade executed at 10:00 AM and another at 10:03 AM will be counted as two separate orders.</p>
             <p className='mt-2'>This rule applies only to trades within the same currency pair. If you take trades in two different pairs, they will be considered multiple positions regardless of timing.</p>
         </div>

     </div>
    </Modal>
      {/* --- Information Modal End --- */}
      </>
  )
}
